// Shared attachment helpers — replaces the per-component copies that
// drifted apart (DMView, GroupChannelView, ChannelInboxView,
// WhatsAppWidgetView, ChatInputBar).

import { ImageIcon, AudioIcon, FileIcon } from '../icons'

export function attachmentIsImage(type?: string): boolean {
  return !!type && (type.startsWith('image/') || type === 'image')
}

export function attachmentIsAudio(type?: string): boolean {
  return !!type && (type.startsWith('audio/') || type === 'audio')
}

export function attachmentIcon(type?: string) {
  if (attachmentIsImage(type)) return <ImageIcon size={16} />
  if (attachmentIsAudio(type)) return <AudioIcon size={16} />
  return <FileIcon size={16} />
}

export function fallbackCopy(text: string): boolean {
  const ta = document.createElement('textarea')
  ta.value = text
  ta.style.position = 'fixed'
  ta.style.top = '0'
  ta.style.left = '0'
  ta.style.opacity = '0'
  ta.setAttribute('readonly', '')
  document.body.appendChild(ta)
  ta.focus()
  ta.select()
  ta.setSelectionRange(0, ta.value.length)
  let ok = false
  try { ok = document.execCommand('copy') } catch { ok = false }
  document.body.removeChild(ta)
  return ok
}

export async function copyToClipboard(text: string): Promise<boolean> {
  // Try the modern Clipboard API first
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // Fall through to fallback
    }
  }
  // Fallback: use a temporary textarea + execCommand
  return fallbackCopy(text)
}
